import Flatpickr from "react-flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

function FlatpickrControlled({ date, onChange }) {
    return (
        <div className="">
            <Flatpickr
                value={date || ''}
                onChange={([selectedDate]) => onChange(selectedDate)}
                options={{
                    altInput: true,
                    altFormat: "d/m/Y",   // exibe assim pro usuário
                    dateFormat: "Y-m-d",  // mas o valor interno fica YYYY-MM-DD
                    locale: Portuguese
                }}
            />
        </div>
    )
}

export default FlatpickrControlled
